import React, { useEffect, useRef, useState } from 'react'
import './badges-landing.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import BadgesList from './badges-list.component';
import BadgesForm from './badges-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { useSelector } from 'react-redux';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { properCase } from '@/utils/properCase';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';

const BadgesLandingPage = ({
  gameData,
  gameElements
}) => {

  const membership = useSelector(state => state.userData.membership);
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [badgesFromDb, setBadgesFromDb] = useState(null);
  const [badgesRetrieved, setBadgesRetrieved] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const elementRef = useRef();
  let elementListener;

  useEffect(() => {

    return () => {
      if (elementListener) elementListener();
    }
  }, [])

  useEffect(() => {
    if (!membership) return;
    checkMembership();
  }, [membership])

  useEffect(() => {
    if (!gameData || badgesRetrieved) return;
    getGameElementsToManage();
    setBadgesRetrieved(true);
  }, [gameData])

  function checkMembership() {
    const element = 'badges'
    const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'element': element })
    // console.log(res);
    if (res.disabled) {
      let message = ''
      const planRest = membershipRestrictions[membership.membership];
      if (res.disabledReason.includes(element)) {
        message = `While using the ${planRest.title}, you are not able to access ${properCase(element)}.`;
      }
      setShowUpgradeModal(message)
    }
  }

  function getGameElementsToManage() {
    if (location.pathname.includes('/preview/manager/')) {
      const badgeObj = {};
      Object.values(completeGameElementData)
        .filter(e => e.type === 'badge' && e.status === 'active')
        .forEach(e => {
          badgeObj[e.id] = e;
        });
      setBadgesFromDb(badgeObj);
      return;
    }
    getCollectionFromDb({
      "collection": `games/${gameData.gameId}/gameElements`,
      "query1": {
        "key": "type",
        "condition": "==",
        "value": "badge"
      },
      "callback": callback,
      "handleListener": handleListener
    })
    function callback(data) {
      elementRef.current = {
        ...elementRef.current,
        ...{ [data.id]: data }
      }
      setBadgesFromDb(elementRef.current);
    }
    function handleListener(data) {
      elementListener = data;
    }
  }

  return (
    <div className='badges-landing'>

      <Routes>
        <Route path='' element={
          <div className='g-card badges-card'>
            <BackButton cancel={() => navigate(-1)} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer src='/images/icons/badges.png' alt='badges icon' className='head-icon' />
              Create and Edit Badges
            </div>
            <hr />
            <div className='badges-landing-content'>
              <BadgesList
                gameElements={gameElements}
                badgesFromDb={badgesFromDb}
                gameData={gameData} />
            </div>
          </div>
        }></Route>
        <Route path='create' element={
          <BadgesForm
            gameElements={gameElements}
            badgesFromDb={badgesFromDb}
            gameData={gameData} />
        }></Route>
        <Route path='edit/:badgePath' element={
          <BadgesForm
            gameElements={gameElements}
            badgesFromDb={badgesFromDb}
            gameData={gameData} />
        }></Route>
        <Route path="*" element={<Navigate replace to="/404" />} />
      </Routes>

      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default BadgesLandingPage